import InputWithAddOn from "@/app/components/ui/Inputs/InputWithAddOn";
import { PRIMARY_BUTTON } from "@/constants";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import DataTable from "@/app/components/ui/Reusable/DataTable";
import SkeletonType1 from "@/app/components/ui/Skeletons/Type1";
import { useAppointmentCartItemsMappingListAPI } from "@/app/hooks/api_hooks/Mappings/useAppointmentCartItemsMappingListAPI";
import { getAppointmentCartItemsMappingColumns } from "@/app/hooks/custom_hooks";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IMappingsState } from "@/app_redux/reducers/slices/auth/mapping_slice";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { TbSearch } from "react-icons/tb";

const AppointmentCartItemListingPage = () => {
  const navigate = useNavigate();
  const hasFetchedRef = useRef(false);
  const { getRouteKey } = useRouter();
  const routeIdConfig = getRouteKey("DATA_MAPPINGS", "id");
  const { routeState } = useRouteInfo(routeIdConfig);
  const { appointmentCartItemsMappingList } = routeState.state as IMappingsState;
  const isCityListInProgress = useLoader("isOnboardCityListInProgress");
  const { NO_APPOINTMENTS } = useImageConstants();
  const columns = getAppointmentCartItemsMappingColumns(navigate, getRouteKey);
  const fetchAppointmentCartItemsMappingList = useAppointmentCartItemsMappingListAPI();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchAppointmentCartItemsMappingList(searchQuery);
      hasFetchedRef.current = true;
    }
  }, []);

  return (
    <div className="px-5 py-3 mt-3">
      <div className="flex items-center">
        <div className="sm:flex-auto">
          <h1 className="font-semibold text-base text-gray-900 leading-6">Appointment Cart Item Mapping</h1>
        </div>
        <div>
          <button
            className={`${PRIMARY_BUTTON} cursor-pointer`}
            onClick={() => navigate(getRouteKey("APPOINTMENT_CART_ITEM_MAPPING_ONBOARD", "url"))}
          >
            Create Mapping
          </button>
        </div>
      </div>
      <div className="flex-1 min-w-[200px] max-w-sm mt-3">
        <InputWithAddOn
          onEnterKeyPress={(query: string) => {
            setSearchQuery(query);
            fetchAppointmentCartItemsMappingList(query);
          }}
          containerClassName="w-full"
          addon={<TbSearch className="w-4 h-4 text-gray-500" />}
          placeholder="Search"
          onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
            const value = (e.target as HTMLInputElement).value;
            if (value === "") {
              setSearchQuery("");
              fetchAppointmentCartItemsMappingList("");
            }
          }}
        />
      </div>
      {isCityListInProgress ? (
        <div className="mt-4">
          <SkeletonType1 />
          <SkeletonType1 className="mt-8" />
        </div>
      ) : appointmentCartItemsMappingList?.length > 0 ? (
        <div>
          <DataTable data={appointmentCartItemsMappingList || []} columns={columns} maxHeight="670px" />
        </div>
      ) : (
        <NoDataFoundComponent
          imageURL={NO_APPOINTMENTS}
          message="No appointment cart item have been onboarded"
          description="No appointment cart item data is available try onboarding it"
        />
      )}
    </div>
  );
};

export default AppointmentCartItemListingPage;
